define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi/enums"
], function(declare,Widget,enums) {

	return declare(Widget, {

		getFieldStore: function(/*Field*/field, /*String*/value) {			
			if (field.m_name == "PrinterName") {				
				return enums.getStore("PrinterNames",value);
			}
			else {
				return this.inherited(arguments);
			}
		}
	
	});
});